let baseUrl = '/api/user-notifications';

let userNotificationsApi = {
    async list(token, companyId, params = {}) {
        const response = await window.axios.get(baseUrl, {
            params: Object.assign({
                api_token: token,
                company_logged: companyId,
            }, params),
        });

        return response.data;
    },

    async unreadCount(token, companyId) {
        const response = await window.axios.get(baseUrl + '/unread-count', {
            params: {
                api_token: token,
                company_logged: companyId,
            },
        });

        return response.data.count || 0;
    },

    async create(payload, token, companyId) {
        const response = await window.axios.post(baseUrl, payload, {
            params: {
                api_token: token,
                company_logged: companyId,
            },
        });

        return response.data;
    },

    async markAsRead(notificationId, token) {
        const response = await window.axios.post(baseUrl + '/' + notificationId + '/read', {}, {
            params: {
                api_token: token,
            },
        });

        return response.data;
    },

    async markAllAsRead(token, companyId) {
        const response = await window.axios.post(baseUrl + '/read-all', {}, {
            params: {
                api_token: token,
                company_logged: companyId,
            },
        });

        return response.data;
    },
};

export default userNotificationsApi;
